export default function useNavigation() {
  const router = useRouter()

  const hasSubnav = computed(() => {
    const route = router.currentRoute.value

    return !!route?.meta?.hasSubnav
  })

  const routeNameWithoutLocale = computed(() => {
    return String(router.currentRoute.value.name).split('_')[0]
  })

  return {
    hasSubnav,
    routeNameWithoutLocale,
  }
}
